module.exports = __webpack_public_path__ + "static/media/perplexity_ai.63e29418.png";